"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onElectronFocus = exports.onWindowFocus = void 0;
var constants_1 = require("./constants");
var typesafe_actions_1 = require("typesafe-actions");
exports.onWindowFocus = (0, typesafe_actions_1.createStandardAction)(constants_1.ON_WINDOW_FOCUS)();
exports.onElectronFocus = (0, typesafe_actions_1.createStandardAction)(constants_1.ON_ELECTRON_FOCUS)();